import React from 'react';

import {SmallLoader} from '@kit';

import {useCharacter} from '../../character-context';
import {StartingEquipmentChoice} from './starting-equipment-choice';
import {useStartingItems} from './use-starting-items';

import css from '../master.module.css';

/** шаг мастера: стартовое снаряжение стартового класса и предыстории — вещи или монеты */
export const EquipmentStep: React.FC = () => {
	const {catalog, state} = useCharacter();
	const {items, titles, loading} = useStartingItems();
	const startingClass = state.classes[0] ? catalog.getClass(state.classes[0].classId) : undefined;
	const origin = state.originId ? catalog.getOrigin(state.originId) : undefined;

	if (!startingClass && !origin) {
		return <p className={css.hint}>Сначала выберите класс и происхождение: от них зависит стартовое снаряжение.</p>;
	}
	if (loading) return <SmallLoader />;

	return (
		<>
			<p className={css.hint}>
				Выбранный вариант сразу попадает в снаряжение и кошелёк. Если передумаете, прежние вещи и монеты
				варианта уберутся.
			</p>
			{startingClass && (
				<StartingEquipmentChoice
					source="class"
					title={`Класс: ${startingClass.title}`}
					text={startingClass.equipment}
					items={items}
					titles={titles}
				/>
			)}
			{origin && (
				<StartingEquipmentChoice
					source="origin"
					title={`Предыстория: ${origin.title}`}
					text={origin.equipment}
					items={items}
					titles={titles}
				/>
			)}
		</>
	);
};
